import React from 'react';

const ScanPlusSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 11.5V8h-1v3.5H8v1h3.5V16h1v-3.5H16v-1h-3.5z"
        />
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M3 16H2v6h6v-1H3zM21 21h-5v1h6v-6h-1zM16 2v1h5v5h1V2zM2 8h1V3h5V2H2z" />
        </g>
    </svg>
);

ScanPlusSvg.displayName = 'ScanPlusSvg';
export default ScanPlusSvg;
